import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion/dist/framer-motion";

import _ from "lodash";

import Leaderboard from "./Leaderboard";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants,
  bounceRightVariants,
  heartBeatVariants,
  logoVariantsExit
} from "../../shared/utils/animations";
import Socket from "../../../socket/socket";
import ttlLogo from "../../../assets/images/ttl/ttl-logo.png";

const Guessing_OverTTL = ({
  asker,
  users,
  roomId,
  status,
  onTimesUp,
  game_state,
  ttl_over_params,
  ttl_guessing_params
}) => {
  const {
    player_guesses,
    current_submission: { answers, correct_answer },
    player_scores
  } = game_state;

  const button_text = _.get(
    ttl_guessing_params,
    "button_text",
    "Everybody has guessed"
  );
  const liar_text = _.get(ttl_guessing_params, "liar_text", "The Player");
  const over_button_text = _.get(ttl_over_params, "button_text", "Play Again?");

  const [countdown, setCountdown] = useState(5);
  const [scoreExit, setScoreExit] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [liarScore, setLiarScore] = useState(null);
  const [playerGuesses, setPlayerGuesses] = useState([]);
  const [submissionArray, setSubmissionArray] = useState({
    0: [],
    1: [],
    2: []
  });
  const [answersArray, setAnswersArray] = useState([
    ...answers?.map((item) => {
      return { answer: item, revealed: false };
    })
  ]);

  useEffect(() => {
    if (countdown === 0) {
      for (let i = 0; i < answersArray.length; i++) {
        if (answersArray.every((c) => c.revealed) === true) {
          setTimeout(() => {
            onTimesUp();
          }, 1100);
          return;
        }
        if (correct_answer !== i) {
          if (answersArray[i].revealed) {
            setTimeout(() => {
              let arr1 = [...answersArray];
              arr1 = arr1.map((c) => {
                return { ...c, revealed: true };
              });
              setAnswersArray([...arr1]);
            }, 1100);
            return;
          } else if (!answersArray[i].revealed) {
            setTimeout(() => {
              let arr = [...answersArray];
              arr[i].revealed = true;
              setAnswersArray([...arr]);
            }, 1000);
            return;
          }
        }
      }
    }
  }, [countdown, answersArray]);

  useEffect(() => {
    if (player_guesses.length === users.length - 1) {
      setShowTimer(true);
    }
  }, [player_guesses]);

  let timer;
  useEffect(() => {
    showTimer &&
      countdown > 0 &&
      (timer = setInterval(() => setCountdown(countdown - 1), 1000));
    return () => clearInterval(timer);
  }, [showTimer, countdown]);

  useEffect(() => {
    if (status === "Over") {
      setShowTimer(false);
      let guessed_lie = 0;
      for (const player of player_guesses) {
        if (player.guess !== correct_answer) {
          guessed_lie += 1;
        }
      }
      if (player_guesses.length === 0) {
        setLiarScore(0);
      } else if (guessed_lie === player_guesses.length) {
        setLiarScore(300);
      } else if (guessed_lie >= Math.ceil(player_guesses.length / 2)) {
        setLiarScore(200);
      } else {
        setLiarScore(0);
      }
    }
  }, [status, users, player_guesses]);

  useEffect(() => {
    !_.isEqual(playerGuesses, player_guesses) &&
      setPlayerGuesses(player_guesses);
  }, [player_guesses]);

  useEffect(() => {
    let arr1 = [];
    let arr2 = [];
    let arr3 = [];
    if (playerGuesses.length === 0) {
      setSubmissionArray({
        0: [],
        1: [],
        2: []
      });
    }
    for (let i = 0; i < playerGuesses.length; i++) {
      const user_image = users?.find(
        (user) => user.player_id === playerGuesses[i].player_id
      )?.profile_image;

      if (playerGuesses[i].guess === 0) {
        arr1 = [...arr1, { profile_image: user_image }];
      } else if (playerGuesses[i].guess === 1) {
        arr2 = [...arr2, { profile_image: user_image }];
      } else {
        arr3 = [...arr3, { profile_image: user_image }];
      }
      setSubmissionArray({
        0: [...arr1],
        1: [...arr2],
        2: [...arr3]
      });
    }
  }, [playerGuesses]);

  const onPlayAgain = () => {
    setScoreExit(true);
    let data = {
      action: "update-status",
      roomId,
      destination: "ChooseAsker"
    };
    setTimeout(() => {
      Socket.sendMessage(data);
    }, 300);
  };

  const timerVariants = {
    hidden: { scale: 1 },
    visible: {
      scale: 1.2,
      transition: {
        duration: 0.5,
        repeat: Infinity,
        repeatType: "reverse"
      }
    }
  };

  const scoreVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      opacity: 1,
      rotate: "12deg",
      scale: [0.3, 1.15, 0.85, 1.1, 1],
      transition: { duration: 0.7 }
    },
    exit: {
      scale: [0.95, 0.85, 1.1, 0.2]
    }
  };

  const truthVariants = {
    hidden: {},
    visible: {
      opacity: 0.5,
      scale: 1,
      transition: {
        duration: 0.5
      }
    },
    exit: {}
  };
  const lieVariants = {
    hidden: {},
    visible: {
      borderColor: "#23D550",
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    },
    exit: {}
  };

  const fadeVariantsGuessing = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };
  const fadeVariantsOver = {
    exit: { opacity: 0 }
  };
  const staticBounceVariantsGuessing = {
    hidden: { scale: 0, opacity: 0 },
    visible: {
      opacity: 1,
      scale: [0.3, 1.15, 0.85, 1.1, 1],
      transition: { duration: 0.7 }
    }
  };
  const staticBounceVariantsOver = {
    exit: {
      scale: [0.95, 0.85, 1.1, 0.2]
    }
  };

  return (
    <>
      <motion.section
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="ttl-guessing-wrapper"
      >
        <motion.img
          variants={status === "Over" ? logoVariantsExit : {}}
          src={ttlLogo}
          className="ttl-logo"
          alt="ttlLogo"
        />
        <motion.h2
          variants={status === "Over" ? fadeVariantsOver : fadeVariantsGuessing}
          className="heading"
        >
          {liar_text}
        </motion.h2>
        <div className="guesser-img">
          <motion.img
            variants={
              status === "Over" ? fadeVariantsOver : fadeVariantsGuessing
            }
            src={asker?.profile_image}
            className="image"
            alt=""
          />
          {status === "Over" && liarScore !== null && liarScore !== 0 && (
            <motion.div className="score" variants={scoreVariants}>
              <p className="inc-num">{`+${liarScore}`}</p>
              <p className="point">points</p>
            </motion.div>
          )}
        </div>
        <motion.h3
          className="guesser-name"
          variants={status === "Over" ? fadeVariantsOver : fadeVariantsGuessing}
        >
          {asker?.display_name}
        </motion.h3>
        {!_.isEmpty(answersArray) &&
          answersArray.map((item, index) => (
            <motion.div
              key={index}
              variants={
                item.revealed
                  ? correct_answer !== index
                    ? truthVariants
                    : lieVariants
                  : status === "Over"
                  ? staticBounceVariantsOver
                  : staticBounceVariantsGuessing
              }
              initial="hidden"
              animate="visible"
              exit="exit"
              className="liar-submission"
            >
              <div className="liar-submission-flex">
                <h2 className="question">
                  {`${index === 0 ? "A" : index === 1 ? "B" : "C"}) ${
                    item.answer
                  }`}
                </h2>
                <div className="liar-images">
                  {submissionArray[`${index}`].length !== 0 &&
                    submissionArray[`${index}`].map(
                      (user, index) =>
                        index < 2 && (
                          <motion.img
                            alt=""
                            key={index}
                            className="liar-img"
                            src={user.profile_image}
                            variants={
                              status === "Over"
                                ? staticBounceVariantsOver
                                : staticBounceVariantsGuessing
                            }
                          />
                        )
                    )}
                  {submissionArray[`${index}`].length > 2 && (
                    <motion.p
                      variants={
                        status === "Over"
                          ? staticBounceVariantsOver
                          : staticBounceVariantsGuessing
                      }
                      className="inc-liar-img"
                    >
                      +{submissionArray[`${index}`].length - 2}
                    </motion.p>
                  )}
                  {status === "Over" && index === correct_answer && (
                    <motion.div
                      variants={scoreVariants}
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      className={`liar-score ${
                        submissionArray[`${index}`].length !== 0 &&
                        "liar-score2"
                      }`}
                    >
                      <p className="inc-num">+100</p>
                      <p className="point">points</p>
                    </motion.div>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        {/* <AnimatePresence> */}
        {showTimer && answersArray.every((c) => !c.revealed) && (
          <motion.div
            // key={3}
            className="timer-div"
            variants={fadeVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <motion.h2 className="timer-text" variants={timerVariants}>
              Revealing in ... <span>{countdown}</span>
            </motion.h2>
          </motion.div>
        )}
        {/* </AnimatePresence> */}

        {((!showTimer && status === "Guessing") || status === "Over") && (
          <motion.button
            variants={staticBounceVariants}
            onClick={
              status === "Guessing" ? () => setShowTimer(true) : onPlayAgain
            }
            className={status === "Guessing" ? "all-guessed" : "play-again-btn"}
          >{`${
            status !== "Over"
              ? button_text +
                " (" +
                playerGuesses.length +
                "/" +
                (users.length - 1) +
                ")"
              : over_button_text
          }`}</motion.button>
        )}
      </motion.section>
      <Leaderboard
        users={users}
        status={status}
        roomId={roomId}
        player_scores={player_scores}
        player_guesses={player_guesses}
        ttl_guessing_params={ttl_guessing_params}
      />
    </>
  );
};

export default Guessing_OverTTL;
